import React from 'react';
import Loader from '../../components/Loader/Loader';
import PlanInfoActionCard from './PlanInfoActionCard';
import TitleAndLinkWrapper from './TitleAndLinkWrapper';
import Wrapper from './Wrapper';
import { removeNumberFromEnd } from "../../helpers/jsHelper";
import { navigateToUpgradePlan } from "./subscriptionHelper";

export const PurchasedPacks = (props) => {
  if (props?.list.length === 0) return null;
  return (
    <Wrapper className="mb-0" style={{ border: 'none' }}>
      <PlanContainer {...props} />
    </Wrapper>
  );
};

export const PlanContainer = ({ list = [], loading, disabledBuyButton = null }) => {
  const description = 'Your paid packs';
  const getFormattedFeatures = (data = []) => data?.map((a) => a.description).join(', ');

  return (
    <>
      <Wrapper className={`mb-4 ${!list?.length ? 'border-0' : ''}`}>
        {loading && <Loader position="absolute" loading backdrop />}
        {!!list?.length && (
          <>
            <TitleAndLinkWrapper
              title="Purchased Packs"
              description={description}
              style={{
                borderLeftStyle: 'none',
                borderRightStyle: 'none',
                borderTopStyle: 'none',
                borderRadius: 0,
              }}
              disabledBuyButton={disabledBuyButton}
              buttonText="Upgrade Plan"
              onClick={() => navigateToUpgradePlan({ value: true })}
            />
            <Wrapper
              className={'p-4'}
              childrenClassName={'gap-3'}
              style={{
                background: '#fff',
                border: 'none',
                borderBottom: '1px solid #e8e8e8',
                borderRadius: 0,
              }}>
              {list.map((a) => (
                <PlanInfoActionCard
                  key={a.product}
                  firstLineIncludeValue={a?.features?.length ? getFormattedFeatures([a?.features?.[0]]) : null}
                  includeValue={a?.features?.length ? getFormattedFeatures(a?.features?.slice(1)) : null}
                  includeLabel={a?.features?.length ? 'Each Includes' : null}
                  title={removeNumberFromEnd(a?.product_name) || ''}
                  cardTitleStyle={{
                    fontSize: 18,
                    color: 'rgba(31, 31, 31)',
                  }}
                  description={
                    a?.total_count ? `Available: ${a?.used_count || 0}/${a?.total_count || 0}` : null
                  }
                />
              ))}
            </Wrapper>
          </>
        )}
      </Wrapper>
    </>
  );
};
